import { CanDeactivateFn, Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth-guard';
import { verifiedGuard } from './shared/guards/verified-guard';
import { roleGuard } from './shared/guards/role-guard';
import Checkout from './pages/checkout/checkout';
import { ERole } from './constants/enum/role';

const checkoutDeactivateGuard: CanDeactivateFn<Checkout> = (component) => component.canDeactivate();

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home').then(m => m.Home)
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about')
  },
  {
    path: 'services',
    loadComponent: () => import('./pages/services/services')
  },
  {
    path: 'testimonials',
    loadComponent: () => import('./pages/testimonials/testimonials')
  },
  {
    path: 'assessment',
    loadComponent: () => import('./pages/assessment/assessment')
  },
  {
    path: 'store',
    loadComponent: () => import('./pages/store/store')
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile'),
    canActivate: [authGuard, verifiedGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'my-assessments' },
      {
        path: 'my-assessments',
        loadComponent: () => import('./pages/profile/my-assessments/my-assessments')
      },
      {
        path: 'send-assessments',
        loadComponent: () => import('./pages/profile/send-assessments/send-assessments'),
        canActivate: [roleGuard(ERole.EMPLOYER, ERole.TEAM_MANAGER)]
      },
      {
        path: 'manage-teams',
        loadComponent: () => import('./pages/profile/manage-teams/manage-teams')
      },
      {
        path: 'manage-teams/team/:id',
        loadComponent: () => import('./pages/profile/manage-teams/team/team'),
        canActivate: [roleGuard(ERole.EMPLOYER, ERole.TEAM_MANAGER, ERole.TEAM_MEMBER)]
      },
      {
        path: 'manage-users',
        loadComponent: () => import('./pages/profile/manage-users/manage-users'),
        canActivate: [roleGuard(ERole.EMPLOYER)]
      },
      {
        path: 'manage-users/member/:id',
        loadComponent: () => import('./pages/profile/manage-users/member-detail/member-detail'),
        canActivate: [roleGuard(ERole.EMPLOYER,ERole.TEAM_MANAGER)]
      },
      {
        path: 'my-profile',
        loadComponent: () => import('./pages/profile/my-profile-tab/my-profile-tab')
      }
    ]
  },
  {
    path: 'take-assessment/:id',
    loadComponent: () => import('./pages/take-assessment/take-assessment'),
    canActivate: [authGuard, verifiedGuard]
  },
  {
    path: 'external-assessment/:id',
    loadComponent: () => import('./pages/take-assessment/take-assessment')
  },
  {
    path: 'checkout/:id',
    loadComponent: () => import('./pages/checkout/checkout'),
    canActivate: [authGuard, verifiedGuard, roleGuard(ERole.EMPLOYER)],
    canDeactivate: [checkoutDeactivateGuard]
  },
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/sign-in/sign-in')
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/reset-password/reset-password')
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/new-password/new-password')
  },
  {
    path: 'change-password',
    loadComponent: () => import('./pages/change-password/change-password'),
    canActivate: [authGuard, verifiedGuard]
  },
  {
    path: 'change-email',
    loadComponent: () => import('./pages/change-email/change-email'),
    canActivate: [authGuard, verifiedGuard, roleGuard(ERole.EMPLOYER)]
  },
  {
    path: 'verify-change-email',
    loadComponent: () => import('./pages/verify-change-email/verify-change-email'),
    canActivate: [authGuard, verifiedGuard]
  },
  {
    path: 'redeem',
    loadComponent: () => import('./pages/redeem/redeem')
  },
  {
    path: 'redeem-assessment/:code',
    loadComponent: () => import('./pages/redeem-assessment/redeem-assessment'),
    canActivate: [authGuard]
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./pages/sign-up/sign-up')
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/verify-email/verify-email'),
    canActivate: [authGuard]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
